var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "story-maker-sticker story-maker-sticker-post",
      on: {
        click: function ($event) {
          return _vm.stickerInstance.nextStyleVariant()
        },
      },
    },
    [
      _c("img", {
        staticClass: "img-change-color",
        attrs: { src: require("@/assets/img/instagram/ehf.png") },
      }),
      _c("p", { staticClass: "text-finish" }, [
        _vm._v(_vm._s(_vm.$t("dash.post-creator.story.done"))),
      ]),
      _c(
        "div",
        {
          class: [
            "sticker-post",
            _vm.stickerInstance.data.typePost,
            `styleVariant${_vm.stickerInstance.data.styleVariant}`,
            _vm.stickerInstance.aspectRatio > 0.5625 ? "containX" : "containY",
          ],
        },
        [
          _vm.stickerInstance.data.styleVariant == 2
            ? _c("div", { staticClass: "sticker-post-header" }, [
                _c("img", {
                  attrs: {
                    src: _vm.stickerInstance.avatar || "img/avatar.jpg",
                  },
                }),
                _c("p", [
                  _vm._v(_vm._s(_vm.stickerInstance.pageName || "auteur")),
                ]),
              ])
            : _vm._e(),
          _vm.stickerInstance.type2 == "video"
            ? _c("video", {
                staticClass: "video media-post",
                attrs: {
                  "data-check-load": "",
                  src: _vm.stickerInstance.url,
                  type: _vm.stickerInstance.fileType,
                  muted: "",
                  playsinline: "",
                  loop: "",
                  autoplay: "",
                  preload: "metadata",
                  onloadedmetadata: "this.muted = true",
                },
                domProps: { muted: true },
              })
            : _c("img", {
                staticClass: "selectDisable media-post",
                attrs: {
                  draggable: "false",
                  "data-check-load": "",
                  src: _vm.stickerInstance.url,
                },
              }),
          _vm.stickerInstance.data.styleVariant == 2 &&
          _vm.stickerInstance.textContentIsEmpty()
            ? _c("div", { staticClass: "sticker-post-footer" }, [
                _c("p", [
                  _c("span", { staticClass: "page-name" }, [
                    _vm._v(_vm._s(_vm.stickerInstance.pageName || "auteur")),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.stickerInstance.data.textContent) +
                      "\n            "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.stickerInstance.data.styleVariant == 1
            ? _c("p", { staticClass: "namePage" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.stickerInstance.data.typePost !== "reel" ? "@" : ""
                    ) +
                    _vm._s(_vm.stickerInstance.pageName || "auteur") +
                    "\n        "
                ),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }